<template>
  <b-card
    class="c-pointer"
    :class="{ hovered: hover || selected }"
    @mouseover="hover = true"
    @mouseleave="hover = false"
  >
    <div v-show="hover || selected" class="space-hover">
      <file-options
        class="kebab"
        v-if="file || file.file"
        :file="file.file ? file.file : file"
        @showAlert="showAlert"
        @shareFile="shareFile"
      ></file-options>
      <b-form-checkbox
        class="left"
        v-model="selected"
        @input="
          selected ? $emit('checkFile', file.id) : $emit('uncheckFile', file.id)
        "
      ></b-form-checkbox>
    </div>
    <b-card-body
      v-show="hover || selected"
      class="card-hovered"
      @click="goToView()"
    >
      <div class="card-details-container--hovered">
        <b-card-title>
          <h5 class="font-weight-bold">{{ file.name }}</h5>
        </b-card-title>
        <div class="d-flex w-100 just1ify-content-between">
          <div>
            <b-card-sub-title class="mb-2">
              <h6 class="gray--2">
                Owned by
                {{
                  file.user && file.user.mine
                    ? 'You'
                    : file.file && file.file.user.mine
                    ? 'You'
                    : file.user && !file.user.mine && file.shared_by
                    ? file.shared_by.full_name
                    : file.file.user && !file.file.user.mine && file.shared_by
                    ? file.shared_by.full_name
                    : ''
                }}
              </h6>
            </b-card-sub-title>
            <b-card-sub-title class="small mt-1 gray--3">
              <span v-show="isShareable">
                <b-icon icon="eye" class="mr-1"></b-icon>
                {{ fileSharesCount }} people
                <span class="mx-1">|</span>
              </span>
              {{ uploaded }}
              <b-img
                :src="require('@/assets/icons/pin.svg')"
                v-if="file.is_pinned"
                class="pin"
              ></b-img>
            </b-card-sub-title>
          </div>
        </div>
      </div>
      <b-card no-body class="image-container image-hovered">
        <b-img-lazy
          v-if="file || file.files.length"
          class="border-0 rounded-0 image"
          v-bind="mainProps"
          :src="fileSrc"
        ></b-img-lazy>
      </b-card>
      <b-card-footer class="px-0 pt-1">
        <h5>
          <b-badge
            pill
            :variant="statusBadge(fileStatus)"
            class="badge-hovered text-capitalize"
          >
            {{ fileStatus }}
          </b-badge>
        </h5>
      </b-card-footer>
    </b-card-body>

    <b-card-body v-show="!hover && !selected" class="p-0">
      <div class="card-details-container">
        <b-card-title>
          <h5 class="font-weight-bold">{{ file.name }}</h5>
        </b-card-title>
        <div class="d-flex w-100 justify-content-between">
          <div>
            <b-card-sub-title class="mb-2">
              <h6 class="gray--2">
                Owned by
                {{
                  file.user && file.user.mine
                    ? 'You'
                    : file.file && file.file.user.mine
                    ? 'You'
                    : file.user && !file.user.mine && file.shared_by
                    ? file.shared_by.full_name
                    : file.file.user && !file.file.user.mine && file.shared_by
                    ? file.shared_by.full_name
                    : ''
                }}
              </h6>
            </b-card-sub-title>
            <b-card-sub-title class="small mt-1 gray--3">
              <span v-show="isShareable">
                <b-icon icon="eye" class="mr-1"></b-icon>
                {{ fileSharesCount }} people
                <span class="mx-1">|</span>
              </span>
              {{ uploaded }}
              <b-img
                :src="require('@/assets/icons/pin.svg')"
                v-if="file.is_pinned"
                class="pin"
              ></b-img>
            </b-card-sub-title>
          </div>
        </div>
      </div>
      <b-card no-body class="image-container">
        <b-img-lazy
          v-if="file || file.files.length"
          class="border-0 rounded-0 image"
          :class="file.mime_type === 'image/jpeg' ? 'object-fit' : ''"
          v-bind="mainProps"
          :src="fileSrc"
        ></b-img-lazy>
      </b-card>
      <b-card-footer class="px-0 pt-1">
        <h5>
          <b-badge
            pill
            :variant="statusBadge(fileStatus)"
            class="badge-hovered text-capitalize"
          >
            {{ fileStatus }}
          </b-badge>
        </h5>
      </b-card-footer>
    </b-card-body>
    <b-alert
      class="custom-alert"
      :show="dismissCountDown"
      dismissible
      fade
      variant="primary"
      @dismiss-count-down="countDownChanged"
      >File has been {{ alertMsg }}.</b-alert
    >
  </b-card>
</template>

<script>
import { mapGetters } from 'vuex'
import FileOptions from '@/components/modals/FileOptions'
export default {
  components: {
    FileOptions
  },

  props: {
    file: {
      type: Object,
      default: null
    },
    selectedFiles: {
      type: Array
    },
    isRequestsFilesPage: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      hover: false,
      mainProps: {
        center: true,
        width: 'auto'
      },
      selected: false,
      dismissCountDown: 0,
      alertMsg: ''
    }
  },

  computed: {
    ...mapGetters('auth', ['user']),
    isBusinessAdminUser() {
      return this.user ? this.user.user_type === 'business_admin' : false
    },
    uploaded() {
      return this.getTimeDiff(this.file.updated_at)
    },
    fileSrc() {
      let file =
        this.$route.name === 'home.welcome-page' && this.isBusinessAdminUser
          ? this.file.file
          : this.file
          ? this.file.file
            ? this.file.file
            : this.file
          : this.file

      return file
        ? file.files && file.files.length
          ? file.files[0].thumb_url
          : `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='%230066FF' class='bi bi-file-earmark' viewBox='0 0 16 16'%3E%3Cpath d='M14 4.5V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h5.5L14 4.5zm-3 0A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4.5h-2z'/%3E%3C/svg%3E`
        : `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='%230066FF' class='bi bi-file-earmark' viewBox='0 0 16 16'%3E%3Cpath d='M14 4.5V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h5.5L14 4.5zm-3 0A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4.5h-2z'/%3E%3C/svg%3E`
    },
    fileSharesCount() {
      return this.file.file_shares ? this.file.file_shares.length : 0
    },
    fileStatus() {
      return this.file && !this.file.file
        ? this.file.status
            .trim()
            .toLowerCase()
            .replace(/\w\S*/g, w => w.replace(/^\w/, c => c.toUpperCase()))
        : this.file && this.file.file
        ? this.file.file.status
            .trim()
            .toLowerCase()
            .replace(/\w\S*/g, w => w.replace(/^\w/, c => c.toUpperCase()))
        : ''
    },
    isShareable() {
      return (
        this.file.status === 'valid' ||
        this.file.status === 'not started' ||
        this.file.status === 'expiring soon'
      )
    }
  },

  methods: {
    goToView() {
      if (this.isRequestsFilesPage) {
        this.$router.replace({
          name: 'request.view-file-page',
          params: { id: this.file.id }
        })
      } else {
        this.$router.replace({
          name: 'file.view-page',
          params: { id: this.file.file_id ? this.file.file_id : this.file.id }
        })
      }
    },
    showAlert(action) {
      this.dismissCountDown = 1
      this.alertMsg = action
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    shareFile() {
      this.$emit('shareFile', this.file)
    },
    statusBadge(status) {
      return status === 'Valid'
        ? 'success'
        : status === 'Pending Approval'
        ? 'warning'
        : status === 'Rejected'
        ? 'danger'
        : 'secondary'
    }
  },

  watch: {
    selectedFiles(newVal, oldVal) {
      const index = newVal.findIndex(f => f === this.file.id)

      this.selected = !(index < 0)
    }
  }
}
</script>

<style lang="scss" scoped>
.card {
  width: 342px;
  height: 355px;
}
.card-details-container {
  &--hovered {
    padding-bottom: 0.25rem;
  }

  background-color: white;
  padding-bottom: 0.75rem;
}
.card-body {
  padding: 1.5rem;
}
.card-footer {
  border: 0;
  background: transparent;
}
.image-container {
  width: 100%;
  height: 200px;
  border: 2px solid #e1e6ea;
  border-radius: 8px;
}
.image {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.image-hovered {
  height: 125px;
}
.pin {
  width: 16px;
  height: 16px;
}
.left {
  position: absolute;
  top: 0;
  left: 20px;
}
.custom-control-label::before {
  width: 24px;
  height: 24px;
  background-color: #d0e4ff !important;
  border: 2px solid #d0e4ff !important;
}
.kebab {
  top: 0px;
  right: 40px;
}
/deep/ .badge-hovered {
  padding: 5px 20px 5px 20px;
  background: #dadde2 0% 0% no-repeat padding-box;
  color: #3f4858 !important;

  &.badge-success {
    background: #d1ffef 0% 0% no-repeat padding-box !important;
    color: #00d392 !important;
  }

  &.badge-danger {
    background: #ffe2e2 0% 0% no-repeat padding-box !important;
    color: #e52c00 !important;
  }

  &.badge-warning {
    background: #fff3cc 0% 0% no-repeat padding-box !important;
    color: #a07602 !important;
  }
}
.hovered {
  background: #eaf3ff 0% 0% no-repeat padding-box;
  box-shadow: 0px 10px 25px #00429d0d;
  display: flex;
  justify-content: center;
  align-items: center;
}
.card-hovered {
  width: 249px;
  height: 259px;
  border-radius: 8px;
  opacity: 1;
  overflow: hidden;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 10px 25px #00429d0d;
  border: 2px solid #006cff;
  padding-top: 1rem;
  padding-left: 1rem;
  padding-right: 1rem;
  // padding-bottom: 0.5rem;
}
.space-hover {
  padding-bottom: 2.5rem;
}
</style>
